// extracted by mini-css-extract-plugin
export default {"documents":"Documents_documents__QbG4N","add_files_cont":"Documents_add_files_cont__lyp2d","close_btn":"Documents_close_btn__rkq88","document_list":"Documents_document_list__Ck7dT"};